import { IntlShape } from "react-intl";
import "../../common/QuotesDetail/quoteColumns.scss";
import { ReactComponent as FireIcon } from "assets/images/icons/Fire.svg";
import { formatNumberV2 } from "helpers/commonHelpers";

const getQuotationDetailListColumn = (intl: IntlShape) => {
  const columns = [
    {
      Header: intl.formatMessage({ id: "new-request.packing-list.commodity", defaultMessage: "Commodity" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b4">{`Commodity ${row.index + 1}`}</div>
        </div>
      ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "new-request.packing-list.handlingUnit", defaultMessage: "Handling unit" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b2">{row.original?.handling_unit}</div>
        </div>
      ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "general.size", defaultMessage: "Size(LxWxH)" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => {
        const { length, width, height } = row.original || {};
        return (
          <div className="d-flex align-items-center">
            <div className="mr-2 font-b2">{length && width && height ? `${length} x ${width} x ${height}` : "-"}</div>
          </div>
        );
      },
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "general.units", defaultMessage: "Units" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b2">{row.original?.units}</div>
        </div>
      ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "quote.unitWeight", defaultMessage: "Units weight" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => {
        const formattedWeight = row.original?.weight
          ? formatNumberV2(row.original?.weight, { minimumFractionDigits: 2, maximumFractionDigits: 4 })
          : "-";
        return (
          <div className="d-flex align-items-center">
            <div className="mr-2 font-b2">x {formattedWeight} Kg</div>
          </div>
        );
      },
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "quote.totalCBM", defaultMessage: "Total CBM" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => {
        const { total_cbm } = row.original;
        return (
          <div className="d-flex align-items-center">
            <div className="mr-2 font-b2">{`${total_cbm ? `${total_cbm?.toFixed(2)} CBM` : "-"} `}</div>
          </div>
        );
      },
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "shipments.weight", defaultMessage: "Weight" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => {
        const { units, weight } = row.original || {};
        return (
          <div className="d-flex align-items-center">
            <div className="mr-2 font-b2">
              {formatNumberV2(units * weight, { minimumFractionDigits: 2, maximumFractionDigits: 4 })} Kg
            </div>
          </div>
        );
      },
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "quote.loadingMeter", defaultMessage: "Loading meters" }),
      accessor: (row: any) => [row],
      Cell: () => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b2">-</div>
        </div>
      ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "quote.info1", defaultMessage: "Info1" }),
      accessor: (row: any) => [row],
      Cell: () => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b2">-</div>
        </div>
      ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "quote.nmfc", defaultMessage: "NMFC" }),
      accessor: (row: any) => [row],
      Cell: () => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b2">-</div>
        </div>
      ),
      disableDrag: true,
    },
    {
      Header: intl.formatMessage({ id: "quote.misc", defaultMessage: "Misc" }),
      accessor: (row: any) => [row],
      Cell: ({ row }: any) => (
        <div className="d-flex align-items-center">
          <div className="mr-2 font-b2">{row.original?.is_dangerous_good ? <FireIcon /> : "-"}</div>
        </div>
      ),
      disableDrag: true,
    },
  ];
  return columns;
};

export default getQuotationDetailListColumn;
